// 定义选择业务数据组件枚举

// 业务类型enum
const ENUM_BUSINESS_TYPE = {
  CUSTOMER: {
    memo: '客户',
    businessType: 100
  },
  CLUE: {
    memo: '线索',
    businessType: 8000
  },
  CHANCE: {
    memo: '机会',
    businessType: 301
  }
}

const ENUM_BUSINESS_TYPE_ENTRIES = Object.keys(ENUM_BUSINESS_TYPE).reduce((prev, key) => {
  const currData = ENUM_BUSINESS_TYPE[key]
  prev[currData.businessType] = ENUM_BUSINESS_TYPE[key]
  return prev
}, {})

export { ENUM_BUSINESS_TYPE, ENUM_BUSINESS_TYPE_ENTRIES }
